import { render, staticRenderFns } from "./AreaCompanyOrderDialog.vue?vue&type=template&id=6c6d1073&scoped=true&"
import script from "./AreaCompanyOrderDialog.vue?vue&type=script&lang=js&"
export * from "./AreaCompanyOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./AreaCompanyOrderDialog.vue?vue&type=style&index=0&id=6c6d1073&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d1073",
  null
  
)

export default component.exports